/**
 * Component Entry
 *
 */

import Button from './Button'
export default Button
export * from './Button'
